export default "__VITE_ASSET__BVkRD_qo__"